import React from 'react';
import "./GiftOrderForm.css";

function GiftOrderForm({ giftDetails, deliveryAddress, onChange, onSave, onClear, onClose }) {
  return (
    <div className="gift-container">
      <div className="gift-header">
        <h2 className="gift-title">Gift this order</h2>
        <button type="button" onClick={onClose} className="gift-close-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>

      <form className="gift-form" onSubmit={onSave}>
        <div className="form-group">
          <label htmlFor="senderName">
            Sender Name<span>*</span>
          </label>
          <input
            id="senderName"
            type="text"
            name="senderName"
            placeholder="Loading your name..."
            value={giftDetails.senderName || ''}
            readOnly
          />
        </div>

        <div className="form-group">
          <label htmlFor="recipientName">
            Recipient Name<span>*</span>
          </label>
          <input
            id="recipientName"
            type="text"
            name="recipientName"
            placeholder="Enter recipient's name"
            value={giftDetails.recipientName || ''}
            onChange={onChange}
            required
          />
        </div>

        <div className="phone-row">
          <div className="country-select">
            <label htmlFor="country">
              Country<span>*</span>
            </label>
            <button id="country" type="button">🇳🇬</button>
          </div>

          <div className="form-group phone-input">
            <label htmlFor="recipientPhone">
              Recipient Number<span>*</span>
            </label>

            <div className="phone-wrapper">
              <span>+234</span>
              <input
                id="recipientPhone"
                type="tel"
                name="recipientPhone"
                placeholder="801 234 5678"
                value={giftDetails.recipientPhone || ''}
                onChange={onChange}
                required
              />
            </div>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="recipientEmail">Recipient Email (Optional)</label>
          <input
            id="recipientEmail"
            type="email"
            name="recipientEmail"
            placeholder="recipient@example.com"
            value={giftDetails.recipientEmail || ''}
            onChange={onChange}
          />
        </div>

        <div className="checkbox-row">
          <input
            type="checkbox"
            name="saveBeneficiary"
            id="save-beneficiary"
            checked={giftDetails.saveBeneficiary || false}
            onChange={onChange}
          />
          <label htmlFor="save-beneficiary">
            Save as beneficiary
          </label>
        </div>

        <div className="delivery-section">
          <p className="delivery-label">
            Where are you sending your gift?
          </p>

          <div className="delivery-address">
            <strong>Delivering to</strong>
            <div className="address-line">
              <div className="address-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
              </div>
              <p>{deliveryAddress}</p>
            </div>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="specialMessage">Add a Special Message (Optional)</label>

          <textarea
            id="specialMessage"
            name="specialMessage"
            rows="4"
            placeholder="Write a short message for the recipient..."
            value={giftDetails.specialMessage || ''}
            onChange={onChange}
          />
        </div>

        <button className="save-btn" type="submit">
          Save Gift Details
        </button>

        <button className="clear-btn" type="button" onClick={onClear}>
          Remove Gift
        </button>
      </form>
    </div>
  );
}

export default GiftOrderForm;